var app = angular.module('leonardo');

var WidgetTemplateSeasonal = function() {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/template-seasonal.html',
    scope: {
      label: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      var ngModelCtrl = ctrls[1];
      scope.enabled = false;

      ngModelCtrl.$render = function() {
        scope.value = ngModelCtrl.$modelValue;
        if (scope.value && (scope.value.from || scope.value.to)) {
          scope.enabled = true;
        }
      };

      scope.$watch('value', function(newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          ngModelCtrl.$setViewValue(scope.value);
          ngModelCtrl.$validate();
        }
      }, true);

      scope.$watch('enabled', function(newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          if (!newValue) {
            if (scope.value) {
              scope.value.from = null;
              scope.value.to = null;
            }
          }
          ngModelCtrl.$setViewValue(scope.value);
          ngModelCtrl.$validate();
        }
      });

      ngModelCtrl.$validators.required = function(modelValue) {
        if ((!scope.enabled) || (modelValue.from && modelValue.to)) {
          return true;
        }
        return false;
      };
    }
  };
};

app.directive('widgetTemplateSeasonal', [WidgetTemplateSeasonal]);
